import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'erp-auth-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: `
   <main class="min-h-screen w-screen overflow-hidden ">
  <router-outlet />
</main>
  `
})
export class AuthLayoutComponent {}
